<div layout-vertical layout-full-width>
  <div
    class="box-header"
    padding-lr
    padding-top
    layout-horizontal
    layout-space-between
    layout-flex-1
  >
    <div text-default-x text-light>
      {{ 'app.interview.summary.scorecard' | translate }}
    </div>
    <div class="light">
      {{ scorecardsResult().title }}
    </div>
  </div>
  <div class="items-wrap">
    @for (option of scorecardsResult().options; track trackByTitle($index, option)) {
      <rt-scorecards-item-row [option]="option" />
    }
  </div>
</div>
